var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "main",
      staticClass: "row v-grid1 p2p-video-main",
      staticStyle: { width: "100%", height: "100%" },
      attrs: { "data-grm-comp": "RoomCallP2P" },
    },
    [
      !_vm.pip
        ? _c(
            "div",
            { staticClass: "video-vip" },
            [
              _vm.mainVideoUser.userId
                ? _c("RoomCallP2PVideo", {
                    staticClass: "main-video",
                    attrs: { user: _vm.mainVideoUser },
                  })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm.subVideoUserList &&
      _vm.subVideoUserList.length > 0 &&
      (_vm.pip || _vm.isRoomMode("call"))
        ? _c(
            "div",
            {
              ref: "subVideos",
              staticClass: "sub-videos",
              attrs: { "data-pip-mode": _vm.pip },
            },
            _vm._l(_vm.subVideoUserList, function (user, idx) {
              return _c("RoomCallP2PVideo", {
                key: user.userId + "@" + user.screenShare,
                staticClass: "sub-video",
                attrs: { user: user, idx: idx, defaultVideoObjectFit: "cover" },
                on: {
                  click: _vm.setMainVideo,
                  mounted: _vm.addSubVideosObserve,
                  destroyed: _vm.removeSubVideosObserve,
                },
              })
            }),
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }